module.exports = __webpack_public_path__ + "img/chevron-left-32x32.b2770399.svg";